var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-stretch",attrs:{"id":"sms-page"}},[_c('navigation'),(_vm.loading)?_c('div',{staticClass:"container-fluid main-content"},[_c('preloader-placeholder',{attrs:{"loading":_vm.loading,"type":'connector'}})],1):[(!this.user.attributes['is-admin'])?_c('sms-conversation'):_c('sms-admin-conversations')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }